import React from 'react';
import './kovin.css';

const YeshwanthSaoji = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/yeshwanth.jpeg" alt="Yeshwanth Saoji" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Yeshwanth Saoji</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
YESHWANT SAOJI is an Optometrist from Nagpur having independent Optometric practice, with specialty contact lenses, binocular vision and Myopia management. 

He holds a Master’s degree from Bharati Vidyapeeth University, Pune and is a Graduate of the Elite School of Optometry (1991), Sankara Nethralaya, Chennai, he is also a Fellow of The L.V.Prasad Eye Institute, Hyderabad, from the first batch (1992), 

He has a lifetime Accreditation as a Fellow of the International Association of Contact Lens Educators, Australia (FIACLE), for his uninterrupted Fellowship for over 15 years. <br /><br />

•	He was awarded the Best Optometrist of the Year 2011 by Sankara Nethralaya, Chennai <br />
•	The Living Legend by Optometry Students Association of AIIMS <br />
•	BIPOK Ambassador for working towards Myopia control awareness in India <br />
•	Alumnus of the year 2021 by the Association of L V Prasad Optometrists <br />
•	Best Optometrist of 2022 by Optometry Confederation of India <br /><br />

He has co-founded Masterclass Optometry and educational initiative with the intent of application-based trainings to make Optometrists practice ready.
            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
 <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>          
 <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default YeshwanthSaoji;